import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { SalesInvoice } from '@tcc-mono/vandijk/shared/data-access/models';
import { SalesInvoiceService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable, map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesInvoiceRepository extends CoreRepository<SalesInvoice> {

  public constructor(
    protected readonly _salesInvoiceService: SalesInvoiceService
  ) {
    super(
      { name: 'salesInvoices' },
      _salesInvoiceService
    );
  }

  public exportToExact = (invoiceId: number): Observable<SalesInvoice> => {
    return this._salesInvoiceService.sendToExact(invoiceId)
      .pipe(
        map(({ data }) => data),
        tap((invoice) => this.addEntitiesInStore([invoice]))
      );
  }
}
